import {EnvInterface} from './env';

export const ENV: EnvInterface = {
  production:true,
  uri:"onedesk",

  url: "",
  port: "",
  version: "2.0",
  fileUrl: "/cware/view/",
  downloadFileUrl: "/cware/download/",
  registrationUrl:"/html/confirmation/",

  dbName: "__onedesk",
  dbLocation: "default",
  cacheName:"od-com-cache:",
  cacheEncrypted:true,
  cacheDefaultTTL: 60*60*12,

  jabberUrl: "wss://"+window.location.host+"/ws",
  jabberAnonymous: "im.onedesk.com",
  jabberConference: "@conference.im.onedesk.com",
  jabberAdminReceiver:"bot@im.onedesk.com",
  jabberAdminSender:"bot2@im.onedesk.com",

  defaultLanguage:"en",
  languages:["en","fr","cus"],

  conversationsApi:"conversations"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts